// @ts-nocheck
import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  .cartographyFilter {
    &__trashButton {
      height: 32px;
      padding: 10px 7.9px;
    }
    &__applyButton {
      height: 32px;
      width: 200px;
    }
  }
`;
